import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { CHECKWORK_WSPOS } from './actionTypes';
import { checkWorkWSPositionSuccessful, checkWorkWSPositionFailed } from './actions';

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const wsposAPI = getWorkstationsAPI();

// Is user register successfull then direct plot user in redux.
function* checkWorkWSPosition({ payload: { ws_pos, value, token , history } }) {
    try {
        const response = yield call(wsposAPI.updateCheckWork, ws_pos, value, token);
        console.log(response);
        history.go()
        yield put(checkWorkWSPositionSuccessful(response.message));

    } catch (error) {
        console.log(error)
        yield put(checkWorkWSPositionFailed(error));
    }
}

export function* watchCheckWorkWSPosition() {
    yield takeEvery(CHECKWORK_WSPOS, checkWorkWSPosition);
}

function* checkWorkWSPositionSaga() {
    yield all([fork(watchCheckWorkWSPosition)]);
}

export default checkWorkWSPositionSaga;